/*!
 * DHL User Interface Library - https://docs.uilibrary.dhl
 *   9fbef606107a605d69c0edbcd8029e5d
 */
import { i as initDUIL } from './initDUIL-a7eb8edd.js';

const globalScripts = initDUIL;

export { globalScripts as g };

//# sourceMappingURL=app-globals-4cca51cb.js.map